import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';

//  FOR DeevExtreme Licensing - BOL
import { licenseKey } from './devextreme-license';
import config from 'devextreme/core/config';

config({
  licenseKey
});
//  FOR DeevExtreme Licensing - EOL 

function App() {
  return <Content />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router basename="/trademarkcomplaints">
      <div className={`app ${screenSizeClass}`}>
        <App />
      </div>
    </Router>
  );
}
